import { render, staticRenderFns } from "./CountrySeminarsSection.vue?vue&type=template&id=fee91ab2&scoped=true"
import script from "./CountrySeminarsSection.vue?vue&type=script&lang=ts"
export * from "./CountrySeminarsSection.vue?vue&type=script&lang=ts"
import style0 from "./CountrySeminarsSection.vue?vue&type=style&index=0&id=fee91ab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee91ab2",
  null
  
)

export default component.exports